/**
 * AREA TYPES CONFIGURATION
 * 
 * 16 area types with dedicated fixture forms
 */

export const AREA_TYPES = [
  { 
    value: 'bathroom', 
    label: 'Bathroom', 
    icon: '🚿',
    hasFixtureForm: true,
    lidarSource: 'polycam',
    fixtureComponent: 'BathroomFixtures',
  },
  { 
    value: 'kitchen', 
    label: 'Kitchen', 
    icon: '🍳',
    hasFixtureForm: true,
    lidarSource: 'polycam',
    fixtureComponent: 'KitchenFixtures',
  },
  { 
    value: 'bedroom', 
    label: 'Bedroom', 
    icon: '🛏️',
    hasFixtureForm: true,
    lidarSource: 'polycam',
    fixtureComponent: 'BedroomFixtures',
  },
  { 
    value: 'living', 
    label: 'Living Room', 
    icon: '🛋️',
    hasFixtureForm: true,
    lidarSource: 'polycam',
    fixtureComponent: 'LivingFixtures',
  },
  { 
    value: 'dining_room', 
    label: 'Dining Room', 
    icon: '🍽️',
    hasFixtureForm: true,
    lidarSource: 'polycam',
    fixtureComponent: 'LivingFixtures', // Uses Living fixtures
  },
  { 
    value: 'hall', 
    label: 'Hall / Entry', 
    icon: '🚪',
    hasFixtureForm: true,
    lidarSource: 'polycam',
    fixtureComponent: 'LivingFixtures', // Uses Living fixtures
  },
  { 
    value: 'office', 
    label: 'Office / Study', 
    icon: '💼',
    hasFixtureForm: true,
    lidarSource: 'polycam',
    fixtureComponent: 'LivingFixtures', // Uses Living fixtures
  },
  { 
    value: 'laundry', 
    label: 'Laundry', 
    icon: '🧺',
    hasFixtureForm: true,
    lidarSource: 'polycam',
    fixtureComponent: 'LaundryFixtures',
  },
  { 
    value: 'mudroom', 
    label: 'Mudroom', 
    icon: '👢',
    hasFixtureForm: true,
    lidarSource: 'polycam',
    fixtureComponent: 'MudroomFixtures',
  },
  { 
    value: 'garage', 
    label: 'Garage', 
    icon: '🚗',
    hasFixtureForm: true,
    lidarSource: 'polycam',
    fixtureComponent: 'GarageFixtures',
  },
  { 
    value: 'basement', 
    label: 'Basement', 
    icon: '🏠',
    hasFixtureForm: true,
    lidarSource: 'polycam',
    fixtureComponent: 'BasementFixtures',
  },
  { 
    value: 'attic', 
    label: 'Attic', 
    icon: '🏚️',
    hasFixtureForm: true,
    lidarSource: 'manual',
    fixtureComponent: 'AtticFixtures',
  },
  { 
    value: 'exterior', 
    label: 'Exterior', 
    icon: '🏡',
    hasFixtureForm: true,
    lidarSource: 'hover',
    fixtureComponent: 'ExteriorFixtures',
  },
  { 
    value: 'roof', 
    label: 'Roof', 
    icon: '🏠',
    hasFixtureForm: true,
    lidarSource: 'hover',
    fixtureComponent: 'RoofFixtures',
  },
  { 
    value: 'deck', 
    label: 'Deck', 
    icon: '🪵',
    hasFixtureForm: true,
    lidarSource: 'hover', // or manual
    fixtureComponent: 'DeckFixtures',
  },
  { 
    value: 'custom', 
    label: 'Custom', 
    icon: '📦',
    hasFixtureForm: false, // Generic form
    lidarSource: 'manual',
    fixtureComponent: null,
  },
];

// Get area type config by value
export const getAreaType = (value) => {
  return AREA_TYPES.find(a => a.value === value) || AREA_TYPES[AREA_TYPES.length - 1];
};

// Get interior area types (Polycam)
export const getInteriorAreaTypes = () => {
  return AREA_TYPES.filter(a => a.lidarSource === 'polycam');
};

// Get exterior area types (Hover)
export const getExteriorAreaTypes = () => {
  return AREA_TYPES.filter(a => a.lidarSource === 'hover');
};

export default { AREA_TYPES, getAreaType, getInteriorAreaTypes, getExteriorAreaTypes };
